import React, { useState } from 'react';
import StepLayout from '../components/StepLayout';
import useEnterKey from '../hooks/useEnterKey';
import { api } from '../api';

/**
 * Step 3 — City. Mirrors youform v0 step 4 ("Enter your location" → City).
 * Plain text input, required.
 *
 * On Continue: PATCHes /sessions/:id/location with { city }. The country
 * selector at step 4 PATCHes the same route again with { country }.
 */
export default function Step03City({ step, totalSteps, sessionId, sessionData, updateData, onNext }) {
  const [city, setCity] = useState(sessionData.city || '');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [submitError, setSubmitError] = useState('');

  const validate = () => {
    if (!city.trim()) {
      setError('This field is required.');
      return false;
    }
    setError('');
    return true;
  };

  const handleSubmit = async (e) => {
    if (e?.preventDefault) e.preventDefault();
    if (!validate()) return;
    setLoading(true);
    setSubmitError('');
    try {
      await api.updateLocation(sessionId, { city: city.trim() });
      updateData({ city: city.trim() });
      onNext();
    } catch (err) {
      setSubmitError(err.message || 'Failed to save city.');
    } finally {
      setLoading(false);
    }
  };

  useEnterKey(() => handleSubmit({ preventDefault: () => {} }), { enabled: !loading });

  return (
    <StepLayout
      title="Enter your city *"
    >
      <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 18 }}>
        <div>
          <label style={{ color: 'var(--text)', fontSize: 13, fontWeight: 600, display: 'block', marginBottom: 6 }}>
            City <span style={{ color: 'var(--danger)' }}>*</span>
          </label>
          <input
            type="text"
            placeholder="Los Angeles"
            value={city}
            onChange={(e) => { setCity(e.target.value); if (error) setError(''); }}
            autoComplete="address-level2"
            // V20 iter-4: youform v0 underline-only input (see Step02PersonalInfo for the pattern)
            style={{ width: '100%', padding: '8px 12px', border: 0, borderBottom: '1px solid var(--border)', borderRadius: 0, fontSize: 20, background: 'transparent', color: 'var(--text)', boxSizing: 'border-box', fontFamily: 'var(--font-sans)' }}
          />
          {error && <p style={{ color: 'var(--danger)', fontSize: 12, marginTop: 4 }}>{error}</p>}
        </div>

        {submitError && <p style={{ color: 'var(--danger)', fontSize: 12 }}>{submitError}</p>}

        <div className="cta-row">
          <button
            type="submit"
            disabled={loading}
            className="cta-row__btn"
            style={{
              background: loading ? 'var(--primary-soft)' : 'var(--primary)',
              color: '#fff',
              padding: 14,
              borderRadius: 8,
              border: 'none',
              fontSize: 16,
              fontWeight: 600,
              cursor: loading ? 'not-allowed' : 'pointer',
              opacity: loading ? 0.85 : 1,
            }}
          >
            {loading ? 'Saving...' : 'Next'}
          </button>
          <span className="enter-hint">press <strong>Enter ↵</strong></span>
        </div>
      </form>
    </StepLayout>
  );
}
